import React from 'react';

import ArrowImg from '@publicImages/svg/arrow-left.svg?icon';

const ArrowLeft = () => <ArrowImg />;

export default ArrowLeft;
